export default "__VITE_ASSET__BGwd5TDO__"